/**
 * Created by Alfredo on Jan-17
 */

import fabric           from  'fabric.js/dist/fabric.require';

//======================================================================================
// Create a 'rectangle' shape
// Targets Behaviors and Workflow canvases.
//======================================================================================
export const TooltipClass = fabric.util.createClass(fabric.Rect, {

    type: 'start',

    initialize: function(fullText, obj, TOOLTIP_WIDTH, canvasWidth) {
        this.fabricObj = obj;
        this.objectCaching = false;
        this.width = TOOLTIP_WIDTH + 10;
        this.tooltip_margin = 5;
        this.height = 0;
        this.fill = '#FFFFFF';
        this.strokeWidth = '1';
        this.stroke = '#799F3F';
        this.isTooltip = true;
        this.fullText = fullText;
        this.tooltip_width = TOOLTIP_WIDTH;
        this.canvasWidth = canvasWidth;

        this.setShadow({
            color: 'rgba(0,0,0,0.6)',
            blur: 10,
            offsetX: 5,
            offsetY: 5,
            opacity: 0.6,
            fillShadow: true, 
            strokeShadow: true 
        });
    },

    toObject: function() {
        return fabric.util.object.extend(this.callSuper('toObject'), {
            label: this.get('label')
        });
    },

    _processBigSingleLine: function(_line, lineWidth, lineIndex, textTrimmed){
        const createLines = Math.floor(lineWidth/(this.tooltip_width-80)); // todo: check for completeness
        let currentLine = lineIndex,
            smallerText = '',
            newTrimPos = 0,
            line = _line;
        
        for (var ii=0 ; ii<createLines ; ii++) {
            newTrimPos = Math.floor( _line.length * (this.tooltip_width-80) / lineWidth);
            smallerText = line.substring(0, newTrimPos);
            line = line.substring(newTrimPos, line.length);

            textTrimmed[currentLine] = smallerText;
            currentLine++;
        }
        return --currentLine;
    },
    _calculateTooltipPosition( lines ) {
        let leftPos = this.fabricObj.left + this.fabricObj.width + this.tooltip_margin + this.tooltip_width > this.canvasWidth
            ? this.fabricObj.left - this.tooltip_width - this.tooltip_margin
            : this.fabricObj.left + this.fabricObj.width + this.tooltip_margin;

        this.height = lines * 20;
        this.left = leftPos;
        this.top = this.fabricObj.top;
        
        let newTop = 0;
        if (this.left < 0) {
            this.top = this.fabricObj.top - this.height - this.tooltip_margin;
            this.left = this.fabricObj.left + (this.fabricObj.width/2) - (this.width/2);
        }

        if (this.top < 0) {
            this.top = this.fabricObj.top + this.fabricObj.height + this.tooltip_margin;
        }
    },
    // TODO pull this up or move it into a utility. It is duplicated in LabeledRectClass
    _drawText: function(ctx) {
        let textTrimmed = [];
        let bText = [];
        let text = this.fullText || "";
        text.split('\n').forEach(o=>{
            const pieces = o.split(' ');
            if (pieces.length > 1) {
                pieces.forEach(j=> bText.push(j));
            } else {
                bText.push(o);
            }
            bText.push('\n');
        });
        let textLength = 0,
            lines = 0;
        textTrimmed[lines] = '';

        for (let i=0, len=bText.length ; i<len ; i++) {
            textLength = ctx.measureText( textTrimmed[lines]+bText[i] );
            if (bText[i] === '\n') {
                lines++;
                textTrimmed[lines] = '';
                continue;
            }
            if (textLength.width > this.tooltip_width-80) {
                let singleLineMeasure = ctx.measureText( bText[i] );
                // single lines longer than 
                if (singleLineMeasure.width > this.tooltip_width-80) {
                    lines = this._processBigSingleLine(bText[i], singleLineMeasure.width, lines, textTrimmed);
                    continue;
                } else {
                    lines++;
                    textTrimmed[lines] = '';
                }
            }
            textTrimmed[lines] += bText[i] + ' ';
        }

        this._calculateTooltipPosition(lines);

        let linesAvailable = Math.floor(this.height/17);
        linesAvailable = linesAvailable > lines ? lines : linesAvailable;
        const startingPointY = - (linesAvailable*17)/2;

        ctx.font = '12px Sans-Serif';
        ctx.fillStyle = 'black';
        ctx.textBaseline = 'hanging';
        
        for (var i=0 ; i<lines ; i++) {
            let startPointX = -(this.tooltip_width/2) + 5;
            ctx.fillText(textTrimmed[i], startPointX, startingPointY + (17*i) + 5);
        }
    },

    _render: function(ctx) {
        this.callSuper('_render', ctx);
        this._drawText(ctx);
    }
});